import { getFirestore, doc, getDoc, getDocFromServer, setDoc, deleteDoc, updateDoc } from 'firebase/firestore'
import { app } from './app'
import { makePath } from './utils'
import { useDocument as useDoc } from 'react-firebase-hooks/firestore'
import castArray from 'lodash/castArray'

const db = getFirestore(app)

export function getDocument(...segments) {
  console.log('getDocument', segments)

  if (!segments.length) {
    return null
  }
  
  return getDoc(doc(db, makePath(...segments)))
}

export function getDocumentFromServer(...segments) {
  console.log('getDocumentFromServer', segments)

  if (!segments.length) {
    return null
  }
  
  return getDocFromServer(doc(db, makePath(...segments)))
}

export function setDocument(value, ...segments) {
  console.log('setDocument', segments)

  if (!segments.length) {
    return null
  }
  
  return setDoc(doc(db, makePath(...segments)), value)
}

export function updateDocument(value, ...segments) {
  console.log('updateDocument', segments)

  if (!segments.length) {
    return null
  }
  
  return updateDoc(doc(db, makePath(...segments)), value)
}

export const useDocument = (path, options) =>
  useDoc(
    doc(db, ...castArray(path)),
    options
  )

export const docRef = (...segments) => doc(db, makePath(...segments))

export const deleteDocument = (...segments) => deleteDoc(doc(db, makePath(...segments)))